import { Controller } from "@hotwired/stimulus"

// A twin note's form (video_notes/new_twin): picking what it's for swaps the
// opening line for that occasion's - but only while the words are still one
// of Jane's openings. Once you've written your own, they stay yours.
export default class extends Controller {
  static targets = ["occasion", "body"]
  static values = { openings: Object }

  swap() {
    const openings = this.openingsValue
    const current = this.bodyTarget.value.trim()
    if (current && !Object.values(openings).some((line) => line.trim() === current)) return

    this.bodyTarget.value = openings[this.occasionTarget.value || "none"] || ""
  }
}
